<template>
  <div class="al-Wrapper">
    <ActivityListBase ref="activityList" :activity-type="ACTIVITY_LOG" :objective="objective">
      <template #activity="{ activity, getActivityTime }">
        <div class="al-Item">
          <AppAvatar :avatar-url="activity.who.icon" no-margins />
          <div class="al-Content">
            <ActivityHeader
              :action="activity.action"
              :name="activity.who.name"
              :time="getActivityTime"
            >
              <template #object>
                <!-- eslint-disable-next-line vue/no-v-html -->
                <span v-html="activity.changedObject" />
              </template>
            </ActivityHeader>
            <div v-if="activity.changedValue" class="al-Description">
              <ContributeLine class="al-ContributeLine" />
              <span v-if="!activity.html" class="al-DescriptionText">
                {{ activity.changedValue }}
              </span>
              <DescriptionField
                v-else
                v-model="activity.changedValue"
                :show-placeholder="false"
                :styled="false"
                :workspace-id="workspaceId"
                readonly
                simple-view
              />
            </div>
          </div>
        </div>
      </template>
      <template #no-results>
        <div class="al-NoItems">
          {{ $t('objective.activity_log_empty') }}
        </div>
      </template>
      <template #loader>
        <ActivityLogLoader />
      </template>
    </ActivityListBase>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { mapState } from 'vuex'

import { ACTIVITY_LOG } from '@/utils/activities'

import ContributeLine from '@/components/objectives/forms/ContributeLine'
import DescriptionField from '@/components/objectives/forms/DescriptionField'
import ActivityHeader from '@/components/objectives/forms/objective-form/ActivityHeader'
import ActivityListBase from '@/components/objectives/forms/objective-form/ActivityListBase'
import AppAvatar from '@/components/ui/AppAvatar/AppAvatar'
import ActivityLogLoader from '@/components/ui/SkeletonLoaders/ActivityLogLoader'

export default defineComponent({
  name: 'ActivityLog',
  components: {
    ActivityListBase,
    ActivityHeader,
    AppAvatar,
    ContributeLine,
    DescriptionField,
    ActivityLogLoader
  },

  props: {
    objective: { type: Object, required: true }
  },

  computed: {
    ...mapState('workspaces', {
      workspaceId: state => state.workspaceId
    }),

    ACTIVITY_LOG: () => ACTIVITY_LOG
  },

  methods: {
    /** @public */
    refreshData() {
      if (this.$refs.activityList?.refreshData) {
        this.$refs.activityList.refreshData()
      }
    }
  }
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/activities';

.al-Wrapper {
  @extend %activities-Wrapper;
}

.al-Item {
  @extend %activities-Item;
}

.al-Content {
  @extend %activities-Content;
}

.al-Description {
  @extend %activities-Description;
}
.al-DescriptionText {
  @extend %activities-DescriptionText;
}
.al-NoItems {
  @extend %activities-NoItems;
}

.al-ContributeLine {
  @extend %activities-ContributeLine;
}
</style>
